// packages block
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// common block
import "./style.css";
import { StudentDetail } from "./components";
import { AddStudentDialog } from "../../../components/dialogs";
// constants, theme, utils and api block
import { setAlert } from "../../../redux/reducers/alert";
import { viewStudent, deleteStudent } from "../../../api/student";
import { PreviousTransactionsTable } from "../../home/components/previousTransactions";
import { Typography } from "@material-ui/core";
import { BLACK } from "../../../theme";

export const InvoiceDetail = (props) => {
  const { studentId } = useParams();
  const [student, setStudent] = useState(null);
  const [isAddStudentDialogVisible, setIsAddStudentDialogVisible] =
    useState(false);
  const [isEditedItem, setIsEditedItem] = useState(null);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const editStudent = () => {
    setIsAddStudentDialogVisible(true);
  };

  const studentDelete = async (id) => {
    try {
      await deleteStudent(id, token);
      showSuccessAlert(t("text_student_deleted_successfully"));
      // deleteCallback(id);
    } catch (err) {
      showErrorAlert(
        err.message || t("text_error_in_deleting_student_please_try_again")
      );
    }
  };

  const closeAddStudentDialog = () => {
    setIsAddStudentDialogVisible(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const { token } = useSelector((state) => state.user);

  const fetchStudent = () => {
    (async () => {
      try {
        const response = await viewStudent(studentId, token);
        if (!response.status) {
          showErrorAlert(
            response?.message || t("text_error_in_fetching_student_detail")
          );
          return;
        }
        setStudent(response?.student);
      } catch (err) {
        showErrorAlert(
          err.message || t("text_error_in_fetching_student_detail")
        );
      }
    })();
  };

  useEffect(() => {
    if (studentId) {
      setStudent(null);
      fetchStudent();
    }
  }, [studentId]);

  return (
    <>
      <Typography
        variant="h4"
        style={{ color: "black", marginBottom: "22px", marginLeft: "35px" }}
      >
        View Student Details
      </Typography>
      <div className="invoice-detail-page">
        <StudentDetail
          student={student}
          editStudent={editStudent}
          studentDelete={studentDelete}
        />
        <div className="invoices-detail-section">
          <PreviousTransactionsTable studentId={studentId} />
        </div>
        {isAddStudentDialogVisible && (
          <AddStudentDialog
            title={"Edit Student"}
            handleClose={closeAddStudentDialog}
            open={isAddStudentDialogVisible}
            successCallback={() => alert("success call back")}
            isEditedItem={student}
            editSuccessCallback={() => {
              closeAddStudentDialog();
              fetchStudent();
            }}
            showCircularProgressBar={true}
          />
        )}
      </div>
    </>
  );
};
